/* eslint-disable */
import browser from './browser';
import { initWXConf } from './wx';

class HybridSchema {
  constructor() {
    this.biggerThanIos9 = false;
    this.g_sUA = navigator.userAgent.toLowerCase();
    if (this.g_sUA.indexOf('like mac os x') > 0) {
      const regStr_saf = /os [\d._]*/gi;
      const verinfo = this.g_sUA.match(regStr_saf);
      let version = (`${verinfo}`).replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.');
      const version_str = `${version}`;
      if (version_str != 'undefined' && version_str.length > 0) {
        // 取第一个数字
        const version_arr = version_str.split('.');
        if (version_arr && version_arr.length) {
          version = version_arr[0] * 1;
          if (version >= 9) {
            this.biggerThanIos9 = true;
          }
        }
      }
    }
    this.isWxJsBridgeReady = false;
  }

  /**
   * format version
   * @param {String} version
   */
  formatVersion(version) {
    const newVersion = version || '';
    const version_arr = newVersion.split('.');
    for (let i = 0, len = version_arr.length; i < len; i += 1) {
      const k = parseInt(version_arr[i]);
      if (k < 10) {
        version_arr[i] = `0${k}`;
      }
    }
    return version_arr.join('.');
  }

  /**
   * get wechat version
   */
  getWeixinVersion() {
    const wechat = this.g_sUA.match(/micromessenger\/([\d.]+)/);
    /* eslint-disable-next-line */
    return this.formatVersion(wechat && wechat[1] || '0');
  }

  /**
   * set schema in app
   * @param {String} schema
   */
  setLocation(schema) {
    if (browser.client == 'wx' && this.getWeixinVersion() >= this.formatVersion('6.5.6')) {
      // wx ready方法
      const wxJsBridgeReady = function (readyCallback) {
        if (readyCallback && typeof readyCallback === 'function') {
          const Api = this;
          const wxReadyFunc = function () {
            readyCallback(Api);
          };
          if (typeof window.WeixinJSBridge === 'undefined') {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', wxReadyFunc, false);
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', wxReadyFunc);
              document.attachEvent('onWeixinJSBridgeReady', wxReadyFunc);
            }
          } else {
            wxReadyFunc();
          }
        }
      };
      wxJsBridgeReady(() => {
        if (this.isWxJsBridgeReady) {
          return;
        }
        this.isWxJsBridgeReady = true;
        if (window.WeixinJSBridge) {
          if (schema.indexOf('nextradio://') > -1) {
            window.WeixinJSBridge.invoke('getInstallState', {
              packageName: 'com.tencent.radio',
              packageUrl: schema,
            }, (e) => {
              if (e && e.err_msg && e.err_msg.indexOf('get_install_state:yes') > -1) {
                /* eslint-disable-next-line */
                schema = schema.replace('nextradio://', '');
                initWXConf().then((appid, wx) => {
                  wx.invoke('launchApplication', {
                    appID: 'wxa9763b5ce513e3f9',
                    parameter: schema,
                    extInfo: schema,
                  }, (res) => {
                    console.log(res);
                  });
                })
                  .fail(() => {
                    console.log('initWXConf fail');
                  });
              }
            });
          } else {
            window.WeixinJSBridge.invoke('launchApplication', {
              schemeUrl: schema,
            }, () => {
            });
          }
        }
      });
    } else {
      // 在浏览器里面的话，比如safari，如果直接location的话，没有安装独立版Qzone的时候会提示"safari打不开网页 因为网址无效"
      // 然而在ios9以上，无法用iframe的方式来呼起schema，所以还是要用location
      // Android机型如果不认这个schema，直接location会导致白屏，所以得用iframe的方式
      try {
        if (this.biggerThanIos9 && !browser.client) {
          window.location.href = schema;
        } else {
          this.callIframe(schema);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  /**
   * open iframe in app
   * @param {String} url
   */
  callIframe(url) {
    const div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = `<iframe id="schemaDiv" src="${url}" scrolling="no" width="0" height="0"></iframe>`;
    document.body.appendChild(div);
    setTimeout(() => {
      document.body.removeChild(div);
    }, 800);
  }
}

export default new HybridSchema();
